import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Header from "@/components/Header";

import Star from './imgs/star@2x.png';
import DeclaimImg from './imgs/declaim@2x.png';
import MainBg from './imgs/main-bg@2x.png';
import PosterImg from './imgs/poster@2x.png';
import ContentPng from './imgs/content@2x.png';
import StartBtn from './imgs/start-btn@2x.png';
import LinkApp from './imgs/link-app@2x.png';
import StartText from './imgs/start-text@2x.png';
import ClickImg from './imgs/click@2x.png';
import ExplainBg from './imgs/explain-bg@2x.png';

import bwmodel from '@/config/bwmodel';
import bridge from '@/config/JSbridge';
import { jumpTo } from '@/utils';
import { useHistory } from 'react-router'
import { activityShare, isStorm, handleUploadTrace } from './stock';

const HomePage = ({ next, isLogin, toRank }) => {
  const [isClick, setIsClick] = useState(false);
  
  const history = useHistory();

  useEffect(() => {
    handleUploadTrace('home', 'visitor')
  }, [])

  const handleNext = () => {
    next();
  }

  const handleClick = () => {
    if (isStorm && !isLogin) {
      bridge.callHandler(
        'nativeEvent',
        {
          event: 'login',
          params: {
            refreshOnBack: true
          }
        },
        () => {}
      );
    } else {
      setIsClick(true);
      handleNext();
    }
  }

  const handleLinkApp = () => {
    /** */
    handleUploadTrace('download-app', 'click')
    
    window.location.href = "https://m.wogoo.com/app/download/wogoo_client/index.html";
  }

  const handleExplain = () => {
    if (isStorm) {
      jumpTo('/active_31/explain');
    } else {
      history.push('/activity/active_31/explain');
    }
  }

  const handleLnikToRank = () => {
    toRank && toRank();
  }

  return (
    <Container>
      {isStorm && 
        <Header
          title="重生之股神模拟器"
          right={<img onClick={activityShare} src={bwmodel.theme === '0' ? require(`@/img/share.png`):require(`@/img/share_dark.png`)} className="share-img" alt=''/>}
          hideNaviBar
        />
      }
      <div className={`page-body ${!isStorm ? 'hide-header' : ''}`}>
        <div className="page-content">
          <img src={MainBg} className='main-bg' alt=''/>
          <img src={DeclaimImg} alt='' className="declaim-img" />
          <img src={DeclaimImg} alt='' className="declaim-img-footer" />
          <div className="poster-img-wrap">
            <img src={PosterImg} alt='' className="poster-img"/>
            {!isStorm && <img onClick={handleLinkApp} src={LinkApp} alt='' className="link-app-img"/>}
            <img src={Star} alt='' className="star-img"/>
            <img src={Star} alt='' className="star-img star-img-top"/>
          </div>
          <div className="content-img-wrap">
            <div className="start-btn-wrap">
              <img src={ContentPng} alt='' className="content-img"/>
              <img src={Star} alt='' className="star-img-decor"/>
              <div className="start-btn">
                <div className="start-btn-box">
                  <img src={StartBtn} className="start-btn-img" alt=""/>
                  <img onClick={handleClick} src={StartText} className={`start-btn-text ${!isClick ? 'text-flash' : ''}`} alt=""/>
                  <img src={ClickImg} className="click-img" alt=""/>
                  <img src={Star} alt='' className="star-img"/>
                </div>
              </div>
            </div>
          </div>
          <div className="explain-item explain-desc" onClick={handleExplain}>
            <div>活动</div>
            <div>说明</div>
          </div>
          {
            isStorm ? (
              <div className="explain-item explain-rank" onClick={handleLnikToRank}>
                <div>排行</div>
                <div>榜单</div>
              </div>
            ) : null
          }
        </div>
      </div>
    </Container>
  );
}

export default React.memo(HomePage);

const Container = styled.div`
  @keyframes flash {
    0% { opacity: 1; }
    25% { opacity: 0; }
    50% { opacity: 1; }
    75% { opacity: 0; }
    100% { opacity: 1; }
  }
  .text-flash {
    animation-name: flash;
    animation-duration: 2s;
    animation-iteration-count: infinite;
  }
  .page-content {
    display: flex;
    flex-direction: column;
  }
  .poster-img-wrap {
    padding: 10px 13.5px 0;
    position: relative;
    z-index: 2;
    .poster-img {
      width: 100%;
      height: auto;
    }
    .link-app-img {
      width: 119px;
      height: 33px;
      position: absolute;
      right: 12px;
      top: 18px;
    }
    .star-img {
      width: 32px;
      height: 32px;
      position: absolute;
      z-index: 4;
      right: 98px;
      top: 44px;
    }
    .star-img-top {
      width: 37.9px;
      height: 37.9px;
      right: 152px;
      top: 14px;
    }
  }
  .content-img-wrap {
    padding-left: 6.5px;
    padding-right: 4px;
    position: relative;
    top: -32px;
    flex: 1;
    .content-img {
      width: 100%;
      height: 100%;
    }
    .start-btn-wrap {
      width: 100%;
      height: 100%;
      position: relative;
      max-height: calc(100% - 40px);
      .star-img-decor {
        width: 49px;
        height: 49px;
        position: absolute;
        z-index: 4;
        right: 20px;
        top: 7px;
      }
      .start-btn {
        position: absolute;
        width: 199px;
        height: 65.5px;
        z-index: 9;
        left: 85.5px;
        bottom: 40.5px;
        .start-btn-box {
          width: 100%;
          height: 100%;
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          .star-img {
            width: 49px;
            height: 49px;
            position: absolute;
            z-index: 4;
            right: -48px;
            top: -22px;
          }
        }
        .start-btn-img {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
        }
        .start-btn-text {
          position: relative;
          z-index: 2;
          width: 111px;
          height: 26.5px;
        }
      }
      
      .click-img {
        width: 59.5px;
        height: 58px;
        position: absolute;
        z-index: 11;
        bottom: -30px;
        right: -30px;
      }
    }
  }
  .explain-item {
    width: 48px;
    height: 55px;
    position: fixed;
    right: 0;
    background-image: url(${ExplainBg});
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 15px;
    font-weight: 500;
    color: #000000;
    line-height: 20px;
    letter-spacing: 2px;
    padding-left: 4px;
    box-sizing: border-box;
  }
  .explain-desc {
    top: 261px;
  }
  .explain-rank {
    top: 321px;
  }
`;


// WEBPACK FOOTER //
// ./src/views/activity_31/home-page.js